import { Heading, HFlow, VFlow } from 'bold-ui'
import { RadioField } from 'components/form'
import { CondicaoMaternalFiltroEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'

import { condicaoMaternalFiltroRecord } from '../../model/model-acompanhamentoCondicaoSaude'

interface AcompanhamentoCondicaoSaudeCondicaoMaternalRadioGroupFieldProps {
  meta: MetaPath<CondicaoMaternalFiltroEnum>
  // TODO (eldorado #35252): remover junto com a flag FILTROS_ACOMPANHAMENTO_CONDICOES_SAUDE_ENABLED
  hideHeading?: boolean
}

export function AcompanhamentoCondicaoSaudeCondicaoMaternalRadioGroupField(
  props: Readonly<AcompanhamentoCondicaoSaudeCondicaoMaternalRadioGroupFieldProps>
) {
  const { meta, hideHeading = false } = props

  return (
    <VFlow>
      {!hideHeading && <Heading level={3}>Condição maternal</Heading>}
      <HFlow alignItems='center'>
        <RadioField
          name={meta}
          value={CondicaoMaternalFiltroEnum.TODAS}
          label={condicaoMaternalFiltroRecord[CondicaoMaternalFiltroEnum.TODAS]}
        />
        <RadioField
          name={meta}
          value={CondicaoMaternalFiltroEnum.GESTANTE}
          label={condicaoMaternalFiltroRecord[CondicaoMaternalFiltroEnum.GESTANTE]}
        />
        <RadioField
          name={meta}
          value={CondicaoMaternalFiltroEnum.PUERPERA}
          label={condicaoMaternalFiltroRecord[CondicaoMaternalFiltroEnum.PUERPERA]}
        />
      </HFlow>
    </VFlow>
  )
}
